import React, { useEffect, useRef } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Header from "../layouts/Header/Header";
import Footer from "../layouts/Footer/Footer";
import AboutUsPage from "../pages/AboutUsPage/AboutUsPage";
import HomePage from "../pages/HomePage/HomePage";
import ContactUsPage from "../pages/ContactUsPage/ContactUsPage";
import BusinessArtCulture from "../pages/BusinessSegmentsPage/ArtCulture";
import BusinessCambridgeFoundation from "../pages/BusinessSegmentsPage/CambridgeFoundation";
import BusinessFamilyOfficePage from "../pages/BusinessSegmentsPage/FamilyOffice";
import BusinessPrivateClub from "../pages/BusinessSegmentsPage/PrivateClub";
import BusinessRealEstatePage from "../pages/BusinessSegmentsPage/RealEstate";
import BusinessTechnologyPage from "../pages/BusinessSegmentsPage/Technology";
import BusinessThinkTank from "../pages/BusinessSegmentsPage/ThinkTank";
import {
  PoliciesCookiesPage,
  PoliciesPrivacyPage,
  PoliciesTermsPage,
} from "../pages/Policies/PoliciesPage";
import Cookie from "../layouts/Cookie/Cookie";
import { Helmet } from "react-helmet";

// import { PoliciesCookies, PoliciesPrivacy, PoliciesTerms } from '../pages/Policies/Policies';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return null;
}

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route
            path="/about"
            element={
              <>
                <Helmet>
                  <title>About Us | NVIG</title>
                  <meta name="description" content="Learn more about our company and team." />
                  <meta name="keywords" content="about us, company, team" />
                </Helmet>
                <AboutUsPage />
              </>
            }
          />
          <Route
            path="/contact"
            element={
              <>
                <Helmet>
                  <title>Contact Us | NVIG</title>
                  <meta name="description" content="Get in touch with us for more information." />
                  <meta name="keywords" content="contact, email, phone" />
                </Helmet>
                <ContactUsPage />
              </>
            }
          />
          <Route
            path="/business/family-office"
            element={
              <>
                <Helmet>
                  <title>Family Office | NVIG</title>
                  <meta name="description" content="Explore our family office services." />
                  <meta name="keywords" content="family office, services, wealth management" />
                </Helmet>
                <BusinessFamilyOfficePage />
              </>
            }
          />
          <Route
            path="/business/real-estate"
            element={
              <>
                <Helmet>
                  <title>Real Estate | NVIG</title>
                  <meta name="description" content="Discover our real estate offerings." />
                  <meta name="keywords" content="real estate, property, investment" />
                </Helmet>
                <BusinessRealEstatePage />
              </>
            }
          />
          <Route
            path="/business/technology-investment"
            element={
              <>
                <Helmet>
                  <title>Technology Investment | NVIG</title>
                  <meta name="description" content="Learn about our technology investment opportunities." />
                  <meta name="keywords" content="technology, investment, innovation" />
                </Helmet>
                <BusinessTechnologyPage />
              </>
            }
          />
          <Route
            path="/business/art-culture"
            element={
              <>
                <Helmet>
                  <title>Art & Culture | NVIG</title>
                  <meta name="description" content="Explore our art and culture initiatives." />
                  <meta name="keywords" content="art, culture, initiatives" />
                </Helmet>
                <BusinessArtCulture />
              </>
            }
          />
          <Route
            path="/business/think-tank"
            element={
              <>
                <Helmet>
                  <title>Think Tank | NVIG</title>
                  <meta name="description" content="Join our think tank for innovative ideas." />
                  <meta name="keywords" content="think tank, innovation, ideas" />
                </Helmet>
                <BusinessThinkTank />
              </>
            }
          />
          <Route
            path="/business/private-club"
            element={
              <>
                <Helmet>
                  <title>Private Club | NVIG</title>
                  <meta name="description" content="Become a member of our exclusive private club." />
                  <meta name="keywords" content="private club, membership, exclusive" />
                </Helmet>
                <BusinessPrivateClub />
              </>
            }
          />
          <Route
            path="/business/cambridge-foundation"
            element={
              <>
                <Helmet>
                  <title>Cambridge Foundation | NVIG</title>
                  <meta name="description" content="Support our Cambridge Foundation initiatives." />
                  <meta name="keywords" content="Cambridge, foundation, support" />
                </Helmet>
                <BusinessCambridgeFoundation />
              </>
            }
          />
          <Route
            path="/policies/cookies"
            element={
              <>
                <Helmet>
                  <title>Cookies Policy | NVIG</title>
                  <meta name="description" content="Read our cookies policy." />
                  <meta name="keywords" content="cookies, policy, privacy" />
                </Helmet>
                <PoliciesCookiesPage />
              </>
            }
          />
          <Route
            path="/policies/privacy"
            element={
              <>
                <Helmet>
                  <title>Privacy Policy | NVIG</title>
                  <meta name="description" content="Learn about our privacy practices." />
                  <meta name="keywords" content="privacy, policy, data protection" />
                </Helmet>
                <PoliciesPrivacyPage />
              </>
            }
          />
          <Route
            path="/policies/terms"
            element={
              <>
                <Helmet>
                  <title>Terms & Conditions | NVIG</title>
                  <meta name="description" content="Review our terms and conditions." />
                  <meta name="keywords" content="terms, conditions, agreement" />
                </Helmet>
                <PoliciesTermsPage />
              </>
            }
          />
          <Route
            path="/"
            element={
              <>
                <Helmet>
                  <title>NVIG</title>
                  <meta name="description" content="Welcome to our company homepage." />
                  <meta name="keywords" content="home, company, welcome" />
                </Helmet>
                <HomePage />
              </>
            }
          />
          <Route
            path="/policies/terms-and-conditions"
            element={
              <>
                <Helmet>
                  <title>Terms & Conditions | NVIG</title>
                  <meta name="description" content="Review our terms and conditions." />
                  <meta name="keywords" content="terms, conditions, agreement" />
                </Helmet>
                <PoliciesTermsPage />
              </>
            }
          />
          <Route
            path="/policies/privacy-policy"
            element={
              <>
                <Helmet>
                  <title>Privacy Policy | NVIG</title>
                  <meta name="description" content="Learn about our privacy practices." />
                  <meta name="keywords" content="privacy, policy, data protection" />
                </Helmet>
                <PoliciesPrivacyPage />
              </>
            }
          />
          <Route
            path="/policies/cookies-policy"
            element={
              <>
                <Helmet>
                  <title>Cookies Policy | NVIG</title>
                  <meta name="description" content="Read our cookies policy." />
                  <meta name="keywords" content="cookies, policy, privacy" />
                </Helmet>
                <PoliciesCookiesPage />
              </>
            }
          />
        </Routes>
      </main>
      <Cookie />
      <Footer />
    </BrowserRouter>
  );
}
